<template>
  <div class="money-table">
    <div class="rank-box">
      <div v-if="professionalRank&&professionalRank.length>0" class="ranktag-box">
        <p class="mb10" style="width: 100%">专业职级：<span style="color:#b8b8b8">（点击职级可直接查看薪酬）</span></p>
        <span
          v-for="(item, index) in professionalRank"
          :id="`professional${poperId}${index}`"
          :key="`professional${poperId}${index}`"
          :class="[activeRank === item ? 'active' : '', 'ranktag-tag']"
          size="mini"
          @click="showPoper(item, `professional${poperId}${index}`)"
        >
          {{ item.专业职级 }}
        </span>
      </div>
      <div v-if="managerialRank&&managerialRank.length>0" class="ranktag-box">
        <p class="mb10" style="width: 100%">管理职级：<span style="color:#b8b8b8">（点击职级可直接查看薪酬）</span></p>
        <span
          v-for="(item, index) in managerialRank"
          :id="`managerial${poperId}${index}`"
          :key="`managerial${poperId}${index}`"
          :class="[activeRank === item ? 'active' : '', 'ranktag-tag']"
          size="mini"
          @click="showPoper(item, `managerial${poperId}${index}`)"
        >
          {{ item.管理职级 }}
        </span>
      </div>
    </div>
    <div v-if="activeRank" class="relate-div">
      <div class="alpha-water-mark-one" style="top:20px">{{ account }}</div>
      <div class="money-table-popper relate-div field-type">
        <p class="pr10">
          <span class="label" style="display: inline;">年限：</span><span class="bolder">{{ activeRank.年限 }}</span>
        </p>
        <p class="pr10">
          <span class="label" style="display: inline;">固薪：</span><span class="bolder">{{ activeRank.固薪 }}</span>
        </p>
        <p class="pr10">
          <span class="label" style="display: inline;">奖金：</span><span class="bolder">{{ activeRank.奖金 }}</span>
        </p>
        <p class="pr10">
          <span class="label" style="display: inline;">全薪：</span><span class="bolder">{{ activeRank.全薪 }}</span>
        </p>
      </div>
    </div>
    <div class="text-box">
      <div v-for="item in showTextFields" :key="item" class="field-type" style="padding-bottom:0px;">
        <p class="label" style="margin-bottom:6px;margin-top:6px;">{{ item }}</p>
        <div style="position:relative;background-color: #2478b526;">
          <div class="alpha-water-mark-one" style="top:20px">{{ account }}</div>
          <pre class="value company-pre">{{ (table.content && table.content[item]) || '' }}</pre>
        </div>
      </div>
    </div>
    <!-- poper -->
    <!-- <Popper
      :id="`newMoneyTable${poperId}`"
      :visible.sync="popperVisible"
      style="z-index: 31;"
      :target-id="popperTarget"
      container="projectTableWrapper"
    >
      <div class="money-table-popper">
        <p class="bolder">{{ activeRank.专业职级 || activeRank.管理职级 }}职级</p>
        <p>年限：<span class="bolder ml10">{{activeRank.年限}}</span></p>
        <p>固薪：<span class="bolder ml10">{{activeRank.固薪}}</span></p>
        <p>奖金：<span class="bolder ml10">{{activeRank.奖金}}</span></p>
        <p>全薪：<span class="bolder ml10">{{activeRank.全薪}}</span></p>
      </div>
    </Popper> -->
  </div>
</template>
<script>
// import Popper from '../../../../../project/src/components/Popper'
import * as fixedvariant from '../../../../../company/statistics/variant/fixedvariant'

const shortid = require('shortid');

const prefessionalSortMap = {}
const managerialSortMap = {}
const levels = ['MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
const options = [{ label: 'ManagingPartner', value: 'ManagingPartner' }, { label: 'Partner', value: 'Partner' }]
levels.forEach(v => {
  const obj = { label: v, value: v, children: [{ label: v, value: v }] }
  for (let i = 1; i < 5; i++) {
    obj.children.push({ label: `${v}${i}`, value: `${v}${i}` })
  }
  options.push(obj)
})

let sortNum = 1
for(let i=options.length;i>0;i--){
  const option = options[i-1]
  if(option.children){
    // eslint-disable-next-line no-loop-func
    option.children.forEach(v=>{
      prefessionalSortMap[v.value] = sortNum++
    })
  }else{
    prefessionalSortMap[option.value] = sortNum++
  }
}
fixedvariant.管理职级表头.forEach((val,index)=>{
  managerialSortMap[val] = index+1
})

export default {
  // components:{ Popper },
  props: {
    table: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      professionalRank: [],
      managerialRank: [],
      textFields: ['奖金机制', '奖金发放时间', '递延机制','考核', '备注'],
      activeRank: {},
      popperVisible: false,
      popperTarget: null,
      poperId:'',
    }
  },
  computed: {
    account() {
      return app.user.account
    },
    showTextFields(){
      const arr = this.textFields
      const result = []
      arr.forEach(v=>{
        if(this.table.content && this.table.content[v]) result.push(v)
      })
      return result
    },
  },
  watch: {
    table: {
      handler(newVal, oldVal) {
        this.init()
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.poperId = shortid.generate()
  },
  methods: {
    init() {
      const { table } = this
      const professionalRank = ((table && table.table) || []).filter(v => v.专业职级)
      const managerialRank = ((table && table.table) || []).filter(v => v.管理职级)
      professionalRank.sort((a,b)=>(prefessionalSortMap[a.专业职级]||0)-(prefessionalSortMap[b.专业职级]||0))
      managerialRank.sort((a,b)=>(managerialSortMap[a.管理职级]||100)-(managerialSortMap[b.管理职级]||100))
      this.professionalRank = professionalRank
      this.managerialRank = managerialRank
      this.activeRank = this.professionalRank[0] || this.managerialRank[0]
    },
    showPoper(data, targetId) {
      this.activeRank = data
      // this.popperVisible = true
      // this.popperTarget = targetId
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
.ranktag-tag {
  display: inline-block;
  cursor: pointer;
  margin: 0 10px 8px 0;
  padding: 4px 12px;
  border-radius: 2px;
  text-align: center;
  line-height:14px;
  color: #467388;
  border: 1px solid #2478b5;
  /* background-color: #0099ff; */
}
.ranktag-tag.active {
  background-color: #8DB9CE;
  border-color: #8DB9CE;
  color:#fff;
}
.money-table-popper {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 4px;
}
.money-table-popper p {
  width: 50%;
}
.pr10 {
  padding-right: 10px;
}
.ranktag-box {
  display: flex;
  flex-wrap: wrap;
}
pre {
  margin: 0;
  text-indent: 0;
  padding: 10px 15px;
  width: 100%;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 1.5;
  color: #262626;
  position: relative;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
.money-table-popper {
  padding: 10px 20px;
  border: 1px solid #eaeefb;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.bolder {
  font-weight: 700;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
